module.exports = __webpack_public_path__ + "static/cp-logo-white.60eddd76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp-logo-white.png
// module id = ./src/assets/cp-logo-white.png
// module chunks = 114276838955818